import ProductField from '../_models/ProductField'
import axios from "axios"
import PriceCalculator from "./PriceCalculator"
import VisibilityConditionController from "./FieldConditions/VisibilityConditionController"
import ConditionPriceCalculator from "./ConditionPriceCalculator";

const sizeFields = ['mirror_size', 'glass_size', 'size']

export default class FormCalculatorController {
    fields = []

    productId
    quantity = 1
    totalPrice = 0
    subtotalPrice = 0
    tax = 0.20

    sizes = {}

    errors = []

    constructor(fields) {
        this.setFieldsList(fields)
    }

    setId(id) {
        this.productId = id
    }

    setFieldsList(fields) {

        if (!fields) {
            return this
        }

        this.fields = (fields.map(field => ProductField.fromPlain(field)) || []).sort((a, b) => {
            return a.position - b.position
        })

        return this
    }

    getFieldsList() {
        return this.fields
    }

    findFieldIndex(field) {
        return this.fields.findIndex((element) => element.id == field.id)
    }

    findField(field) {
        const FieldIndex = this.findFieldIndex(field)

        if (FieldIndex <= -1) {
            return false
        }
        return this.fields[FieldIndex]
    }

    findFieldByName(field) {
        const FieldIndex = this.fields.findIndex((element) => element.id == field)
        if (FieldIndex <= -1) {
            return false
        }
        return this.fields[FieldIndex]
    }

    isFieldDisabled(field) {
        const FieldIndex = this.findFieldIndex(field)

        if (FieldIndex === 0) {
            return false
        }

        if (this.isSizeField(this.fields[FieldIndex - 1]) && this.sizeWasSelected()) {
            return this.checkIsSizeIsNotOverMax();
        }

        if (this.fields[FieldIndex - 1]?.selectedOption !== null) {
            return false
        }

        return true
    }

    /**
     * Get Methods Calculations
     */

    getQuantity() {
        return parseInt(this.quantity)
    }

    setQuantity(number) {

        if (number <= 0) {
            number = 1
        }

        this.quantity = number
    }

    getSelectedFields() {
        return this.fields.filter(field => {
            return field.selectedOption !== null
        })
    }

    setMirrorOrGlassSizeField() {
        const field = (
            this.fields.find(item => item.id === "mirror_size")?.mapToForm ||
            this.fields.find(item => item.id === "glass_size")?.mapToForm ||
            this.fields.find(item => item.id === "size")?.mapToForm
        );

        if (!field) {
            return this.sizes = {
                height: '',
                width: '',
                unit: '',
            }
        }

        if (this.isCircleSelected()) {
            //set the same size for width and height (positions are static)
            field[0].selected.name = field[1].selected.name;
        }

        let output = {}
        field.forEach(item => {
            output[item.id] = item.selected.name
        })

        return this.sizes = output
    }

    getMirrorsSizeField() {
        return this.sizes
    }

    showMinPrice() {
        const sizes = this.getMirrorsSizeField();
        const clean = Object.keys(sizes).filter((field, index) => {
            return sizes[field] !== "";
        });
        return clean.length === Object.keys(sizes).length;
    }

    getTotal() {
        return this.totalPrice = this.getSubtotal() + this.getTaxTotal()
    }

    getSubtotal() {
        let price = 0

        const sizes = this.sizes

        const ConPriceCalculator = new ConditionPriceCalculator()

        ConPriceCalculator.setAllFields(this.getFieldsList())
        ConPriceCalculator.setSelectedFields(this.getSelectedFields())

        this.getSelectedFields().forEach(field => {

            // Calculate price by the price condition on other fields
            const fieldPrice = ConPriceCalculator.getPriceFromSelectedOption(field.selectedOption)

            const priceCalculatorObj = new PriceCalculator(sizes)

            price += priceCalculatorObj.getPriceBySize(fieldPrice, field.selectedOption.min_price, field.selectedOption.type, sizes)

            // price += field.selectedOption ? field.selectedOption.getPrice(sizes) : 0
        })

        return this.subtotalPrice = PriceCalculator.roundUp(price, 2) * this.getQuantity()
    }

    getTotalPrice() {
        return PriceCalculator.roundUp(this.getTotal(), 2).toFixed(2)
    }

    getSubtotalPrice() {
        return PriceCalculator.roundUp(this.getSubtotal(), 2).toFixed(2)
    }

    getTaxPrice() {
        return PriceCalculator.roundUp(this.getTaxTotal(), 3).toFixed(2)
    }

    getTax() {
        return this.tax
    }

    getTaxValue() {
        return this.getTax() * 100
    }

    getTaxTotal() {
        return this.getSubtotal() * this.getTax()
    }

    /**
     * Output Methods
     */

    getFlatData() {
        const data = []
        this.getSelectedFields().forEach(field => {
            if (Array.isArray(field.mapToForm)) {
                field.mapToForm.forEach(item => {
                    data.push({ ...item })
                })
                return
            }
            return data.push({ ...field.mapToForm })
        })
        return data
    }

    getFormData() {
        const data = this.getFlatData()

        let formData = new FormData()

        formData.append('product_id', parseInt(this.productId))
        formData.append('quantity', this.getQuantity())

        data.forEach((field, index) => {
            Object.keys(field).forEach((obj, indexObject) => {
                    if (obj !== 'selected') {
                        formData.append('product_setup[' + index + '][' + obj + ']', field[obj])
                    } else {
                        Object.keys(field[obj]).forEach((selected, indexSelected) => {
                            formData.append('product_setup[' + index + '][' + obj + '][' + selected + ']', field[obj][selected])
                        })
                    }
                }
            )
        })

        return formData
    }

    productValid() {
        this.clearErrors()

        if (!this.allFieldsSelected()) {
            this.errors.push('All fields need be filled.')
        }

        return !this.errors.length
    }

    clearErrors() {
        this.errors = []
    }

    async addItemToCart() {

        if (this.productValid()) {
            const url = wc_add_to_cart_params.wc_ajax_url.toString().replace("%%endpoint%%", "add_to_cart")

            return await axios.post(url, this.getFormData())
        }

        return false
    }

    allFieldsSelected() {
        return this.getSelectedFields().length === this.fields.length
    }

    anyFieldSelected() {
        return this.getSelectedFields().length > 0;
    }

    getErrors() {
        return this.errors
    }

    checkAllFieldVisibilityCondition() {
        const ConditionController = new VisibilityConditionController(this);

        this.getSelectedFields().forEach(field => {

            if (field.selectedOption === false) {
                return;
            }

            if (field.selectedOption.display_conditions.length === 0) {
                return;
            }

            const canBeSelected = !!ConditionController.isFieldOptionShouldBeDisplayed(field.selectedOption);

            if (!canBeSelected) {
                field.selectedOption = null;
            }
        })
    }

    isCircleSelected() {
        const shape = this.fields.find(item => item.id === "176");

        if (shape) {
            if (!!shape.selectedOption && shape.selectedOption.name === 'Circle') {
                return true;
            }
        }
        return false;
    }

    checkIsSizeIsNotOverMax() {
        const priceCalculatorObj = new PriceCalculator(this.getMirrorsSizeField())
        return priceCalculatorObj.getSquareArea() > 4;
    }

    getSizeField() {
        const sizeFieldName =  sizeFields.find(sizeName => {
            return this.findFieldByName(sizeName)
        });
        
        if(!sizeFieldName){
            return null
        }
        
        return this.findFieldByName(sizeFieldName);
    }

    isSizeField(field) {
        return field?.id == 'mirror_size' || field?.id == 'glass_size' || field?.id == 'size';
    }

    sizeWasSelected() {
        const priceCalculatorObj = new PriceCalculator(this.getMirrorsSizeField())
        return priceCalculatorObj.getSquareArea() > 0;
    }

    clearSize() {
        const size = this.getSizeField();

        if (size) {
            size.selectedOption = null;
        }
    }
}
